import { useETSTicketsQueryParams } from 'gcs-common/clients/api/entities/tickets/tickets-api-helpers';
import ErpCustomerDropDown from '../../../../ErpCustomerDropDown/ErpCustomerDropDown';

const ErpCustomerFilter = () => {
  const { etsTicketsfilters, setETSTicketsQueryParams } = useETSTicketsQueryParams();

  const setErpCustomerFilter = (erpCustomerIds: string | undefined) => {
    setETSTicketsQueryParams({
      erpCustomerIds,
    });
  };

  const onSearchErpCustomer = (erpCustomerIds: string | string[] | undefined) => {
    if (Array.isArray(erpCustomerIds)) {
      setErpCustomerFilter(erpCustomerIds.map((x) => encodeURIComponent(x)).join(','));
    }
  };

  const customerIds = (etsTicketsfilters.erpCustomerIds || '').split(',');

  return (
    <div className="w-[500px]">
      <ErpCustomerDropDown
        value={customerIds}
        onChange={onSearchErpCustomer}
        isClearable
        isMulti
        placeholder="Kunden suchen"
      />
    </div>
  );
};

export default ErpCustomerFilter;
